import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { CheckMarkFillLegacy } from '@lyearn/icons';
import { Box, Stack, Typography } from '@lyearn/ui';
import LinearProgress from '@/components/LinearProgress';

interface ProgressProps {
  progress: number;
}

const ProgressBar = ({ progress }: ProgressProps) => {
  const { t } = useTranslation();

  return (
    <Box className="mt-auto">
      {progress === 100 ? (
        <Stack alignItems="center" className="flex-row items-center h-[2.2rem]" gapX={6}>
          <CheckMarkFillLegacy className="h-16 w-16 self-center" fillColorToken="icon-success" />
          <Typography color="text-text-success" variant="label-02">
            {t('Common:Filter.Completed')}
          </Typography>
        </Stack>
      ) : (
        <LinearProgress
          className="mb-4"
          color={progress === 100 ? 'success' : 'primary'}
          size="small"
          value={progress}
          width={86}
        />
      )}
    </Box>
  );
};

export default React.memo(ProgressBar);
